import React from "react";
import PropTypes from "prop-types";

function ButtonBasic({ id = 'deq-primary', label, ariaLabel, type = 'button', disabled = false, cypressid, cy, style: userStyles = {}, onClick, children, props }) {
  return (
    <button
      disabled={disabled}
      style={{ minHeight: '44px', ...userStyles }}
      className={`btn m-2${id ? ` ${id}` : ''}`}
      type={type}
      onClick={onClick}
      data-cy={cy || cypressid}
      aria-label={ariaLabel || undefined}
      {...props}
    >
      {label}
      {children}
    </button>
  );
}

ButtonBasic.propTypes = {
  label: PropTypes.string,

  ariaLabel: PropTypes.string,

  /** Background color to use:
   * Refer to the CSS 'themes' file for all possible background color references
   */

  id: PropTypes.string,

  /** style object - Allow users to create inline styles */
  style: PropTypes.object,

  /**Type of Button */
  type: PropTypes.string,

  /** Notes whether or not button is clickable */
  disabled: PropTypes.bool
};

export default ButtonBasic;
